import React, { useRef } from 'react';

import './Input.scss';

const Input = props => {
  const InputClasses = ['Input', props.errorMessage ? 'Error' : ''];
  const inputRef = useRef(null)

  const keydown = evt => {
    if(evt.which === 13) {
      inputRef.current.blur()
    }
  }

  return (
    <div className={InputClasses.join(' ')}>
      <label className="label" htmlFor={props.id}>
        <span className={props.hideLabel ? 'sr-only' : null}>{props.label}</span>
        <input type={props.type}
          ref={inputRef}
          onKeyDown={keydown}
          placeholder={props.placeholder}
          value={props.value}
          id={props.id}
          autoComplete="off"
          step={props.step}
          maxLength={props.maxLength}
          onChange={props.changed} />
      </label>
    </div>
  )
}

export default Input;